import { unwrapResult } from '@reduxjs/toolkit';
import { useCallback } from 'react';

import {
    clearAllAction,
    clearErrorsAction,
    getAllUpcomingEvents,
} from './actions';
import {
    errorMessageUpcomingEventsSelector,
    isFetchingUpcomingEventsSelector,
    scopedUpcomingEventsSelector,
} from './selectors';
import { useAppDispatch, useAppSelector } from '../hooks';
import { AppDispatch } from '../store';

export const useUpcomingEventsStore = () => {
    const dispatch: AppDispatch = useAppDispatch();
    const isFetching = useAppSelector(isFetchingUpcomingEventsSelector);
    const errorMessage = useAppSelector(errorMessageUpcomingEventsSelector);
    const upcomingEvents = useAppSelector(scopedUpcomingEventsSelector);

    const getAll = useCallback(
        (args: { customerId: number }) => {
            return dispatch(getAllUpcomingEvents(args)).then(unwrapResult);
        },
        [dispatch]
    );

    const clearAll = useCallback(
        () => dispatch(clearAllAction()).then(unwrapResult),
        [dispatch]
    );

    const clearErrors = useCallback(
        () => dispatch(clearErrorsAction()).then(unwrapResult),
        [dispatch]
    );

    return {
        isFetching,
        errorMessage,
        upcomingEvents,
        getAll,
        clearAll,
        clearErrors,
    } as const;
};
